// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    overflow: hidden; 
}

.App-module__appContainer--oFG67 {
    display: flex;
    height: calc(100vh - 120px); 
    padding: 10px;
    box-sizing: border-box;
    gap: 20px;
    overflow: hidden; 
}

.App-module__content--m748d {
    flex-grow: 1;
    padding: 0 16px;
    overflow-y: auto; 
    height: 100%;
    border-radius: 14px;
    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
}


.App-module__titleBox--ch4JJ {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.App-module__titleBox--ch4JJ>h1 {
  color: #6F879C;
  font-size: 30px;
  font-weight: 500;
}
.App-module__titleBox--ch4JJ>h1>span {
    color: #0054E6;
}

.App-module__iconSort--aRDxZ {
    display: flex;
    justify-content: flex-end;
}
.App-module__iconSelected--BLyeW > svg {
    color: #0054E6;
}


.App-module__infoBox--jDweZ {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
}

.App-module__infoBox--jDweZ>p {
    font-size: 25px;
    color: #6f879c70;
    font-weight: 500;
}


.App-module__btnBack--aVXHh {
    text-transform: none !important;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: 70px;
    gap: 10px;
    color: #0054E6 !important;
}
.App-module__alertBox--B54V3 {
    display: flex;
    justify-content: center;
    align-items: center;
}

@media (max-width: 1370px) {
    .App-module__titleBox--ch4JJ {
        flex-direction: column;
        justify-content: normal;
        align-items: normal;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/app/providers/theme/App.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,2DAA2D;IAC3D,wDAAwD;IACxD,mDAAmD;AACvD;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,+BAA+B;IAC/B,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;EACF","sourcesContent":["body {\r\n    margin: 0;\r\n    padding: 0;\r\n    overflow: hidden; \r\n}\r\n\r\n.appContainer {\r\n    display: flex;\r\n    height: calc(100vh - 120px); \r\n    padding: 10px;\r\n    box-sizing: border-box;\r\n    gap: 20px;\r\n    overflow: hidden; \r\n}\r\n\r\n.content {\r\n    flex-grow: 1;\r\n    padding: 0 16px;\r\n    overflow-y: auto; \r\n    height: 100%;\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n}\r\n\r\n\r\n.titleBox {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.titleBox>h1 {\r\n  color: #6F879C;\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n}\r\n.titleBox>h1>span {\r\n    color: #0054E6;\r\n}\r\n\r\n.iconSort {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n.iconSelected > svg {\r\n    color: #0054E6;\r\n}\r\n\r\n\r\n.infoBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.infoBox>p {\r\n    font-size: 25px;\r\n    color: #6f879c70;\r\n    font-weight: 500;\r\n}\r\n\r\n\r\n.btnBack {\r\n    text-transform: none !important;\r\n    display: flex;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    height: 70px;\r\n    gap: 10px;\r\n    color: #0054E6 !important;\r\n}\r\n.alertBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n@media (max-width: 1370px) {\r\n    .titleBox {\r\n        flex-direction: column;\r\n        justify-content: normal;\r\n        align-items: normal;\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appContainer": `App-module__appContainer--oFG67`,
	"content": `App-module__content--m748d`,
	"titleBox": `App-module__titleBox--ch4JJ`,
	"iconSort": `App-module__iconSort--aRDxZ`,
	"iconSelected": `App-module__iconSelected--BLyeW`,
	"infoBox": `App-module__infoBox--jDweZ`,
	"btnBack": `App-module__btnBack--aVXHh`,
	"alertBox": `App-module__alertBox--B54V3`
};
export default ___CSS_LOADER_EXPORT___;
